const NAME = "SPECIAL_PROCESS_DEFINITION";

export default NAME;
